module.exports = __webpack_public_path__ + "static/images/containers/ClanPanel/components/Item/images/icon-crystal.RU.e0f321ad.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanPanel/components/Item/images/icon-crystal.RU.png
// module id = 3071
// module chunks = 11